<script>

import ENV from '@src/env'
import downloadFile from '@utils/download-file';
import Lottie from 'vue-lottie';
import * as animationData from '@assets/animations/lottie/check_animation.json';
import { mapState } from 'vuex'

export default {
  name: 'CloseReorderProduductsFlowWidget',
  components: {
    Lottie,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      defaultOptions: {
        animationData: animationData.default
      },
      animationSpeed: 1,
      documents: [],
    }
  },
  computed: {
    ...mapState('widgets', {
      timId: state => state.common.query.tim_id,
      token: state => state.common.query.token,
      countryCode: state => state.common.query.country_code.toUpperCase()
    }),
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
    async download(e) {
      e.preventDefault();
      const config = {
        url: `${ENV.rappi.url[this.countryCode]}/api/ticket-manager/tickets/${this.timId}/document/custom-fields`,
        headers: { authorization: `Bearer ${ this.token }`, auth_owner: 'application_users' }
      };
      downloadFile(config)
    }
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__content">

      <lottie
        :options="defaultOptions"
        :height="150"
        :width="150"
        @animCreated="handleAnimation"
      />

      <h2>{{ $t('WIDGETS.COMMON.MESSAGE_SEND') }}</h2>
      <p :class="$style.container__content__copy">{{ $t('WIDGETS.COMMON.CONTACT_EMAIL') }}{{ componentData.userEmail ? ":" : '' }}</p>
      <p :class="$style.container__content__copy"><span>{{ componentData.userEmail }}</span> {{ $t('WIDGETS.COMMON.AND_SUPPORT_SECTION_APP') }}.</p>
      <br>
      <p 
        v-if="timId"
        :class="$style.container__content__copy">
        {{ $t('WIDGETS.COMMON.DOWNLOAD_DOCUMENT_COPY') }}, <a @click="download($event)">{{ $t('WIDGETS.COMMON.HERE') }}</a>
      </p>
    </div>
  </div>
</template>


<style lang="scss" scoped module>
@import '@design';

.container {
  padding: 0.5rem 0;
  min-height: 70vh;

  &__content {
    padding: 2rem;
    img {
      max-width: 7rem;
      max-height: 7rem;
      margin: 1rem;
    }

    h2 {
      @extend %typography-xlarge;

      margin-bottom: 1.5rem;
      color: $options-color;
    }

    &__copy {
      @extend %typography-large;

      margin: 0;
      font-weight: 420;
      color: $secondary-text;
    }

    &__legal {
      @extend %typography-small;

      margin: 1.5rem 0.5rem -1.5rem 0;
      font-style: italic;
      font-weight: 420;
      text-align: right;
    }

    &__extraCopy {
      @extend %typography-small;

      margin: 1.5rem 0.5rem -1.5rem 0;
      font-style: italic;
      font-weight: 420;
      margin-top: 5rem;
    }

    span {
      display: block;
      font-weight: bold;
      color: $text-color-secondary;
      word-wrap: break-word;
    }
  }
}
</style>
